import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../App";

const SESSION_KEY = "rivones_sid";

function ensureSessionId() {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = `sess_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return null;
  }
}

function readUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const out = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(
      (k) => {
        const v = params.get(k);
        if (v) out[k] = v;
      }
    );
    // Persist UTM for the session so we attribute later page views too
    if (Object.keys(out).length) {
      sessionStorage.setItem("rivones_utm", JSON.stringify(out));
      return out;
    }
    const stored = sessionStorage.getItem("rivones_utm");
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

/** Fires a single pageview per route change. */
export default function usePageViewTracker() {
  const location = useLocation();
  const last = useRef(null);

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    if (last.current === path) return;
    last.current = path;
    const payload = {
      path,
      referrer: document.referrer || null,
      utm: readUtm(),
      session_id: ensureSessionId(),
    };
    // Fire-and-forget; never block navigation
    api.post("/track/pageview", payload).catch(() => {});
  }, [location.pathname, location.search]);
}
